"use client";

import { format } from "date-fns";
import { CalendarIcon } from "lucide-react";

import { DateSelectorPopover } from "./date-selector-popover";

export interface DueDateSelectorProps {
  /** Current due date (epoch ms) or null */
  value: number | null;
  /** Callback when date changes — null means cleared */
  onSelect: (date: number | null) => void;
  /** Whether the selector is disabled */
  disabled?: boolean;
}

export function DueDateSelector({ value, onSelect, disabled = false }: DueDateSelectorProps) {
  const selected = value == null ? undefined : new Date(value);

  return (
    <DateSelectorPopover
      value={value}
      selected={selected}
      calendarSelected={selected}
      disabled={disabled}
      icon={CalendarIcon}
      placeholder="Due date"
      formattedValue={selected ? format(selected, "MMM d, yyyy") : null}
      removeLabel="Remove due date"
      onCalendarSelect={(day) => onSelect(day.getTime())}
      onRemove={() => onSelect(null)}
      closeOnCalendarSelect
      renderFooter={(removeButton) =>
        removeButton ? (
          <div className="border-t border-border px-3 py-2 [&>button]:w-full">{removeButton}</div>
        ) : null
      }
    />
  );
}
